/* eslint function-paren-newline:0 */
const AccessContext = require('../contexts/access-context');

const SocialPost = require('../../entities/social-post');

const multipleFields = ['id', 'scheduledDate', 'socialNetwork', 'socialNetworkUrl', 'state', 'displayState', 'output', 'relatedEntities', 'campaignName', 'contentType', 'lastNotified'];
const errorFields = ['error(code,message)'];
const singleFields = [...multipleFields, ...errorFields, 'variables(id,type,value)', 'debug.calls(key,in,out,success)'];
const createFields = multipleFields.filter(f => f !== 'lastNotified');

class SocialPostsRepo {
  constructor(client
  /*: ApiClient*/
  , context
  /*: AccessContext*/
  ) {
    this.client = client;
    this.context = context; // eslint-disable-next-line no-use-before-define

    this.for = (id
    /*: postId*/
    ) => new SocialPostRepo(client, id, this.context);

    this.icanhas = this.for;
  }

  listAll({
    /*: {
        stateGroup?: string,
        contentType?: string,
        cursor?: string
      }*/

    stateGroup,
    contentType,
    cursor
  }, options
  /*: RequestOptions*/
  = {}) {
    const req = new this.client.Request(`/social/posts`, {
      stateGroup,
      contentType,
      cursor
    }, options.fields || [...multipleFields, ...errorFields]);
    req.parse = SocialPost.parse;
    return this.client.get(req);
  }

  list({
    stateGroup,
    contentType,
    rangeStart,
    rangeEnd
  } = {}, options
  /*: RequestOptions*/
  = {}) {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/posts`, {
      stateGroup,
      contentType,
      rangeStart,
      rangeEnd
    }, options.fields || multipleFields);
    req.parse = SocialPost.parse;
    return this.client.get(req);
  }

  create({
    /*: {
          socialNetwork: string,
          contentType: string,
          imageRefId: string,
          message: ?string,
          scheduledDate: string
        }*/

    socialNetwork,
    contentType,
    imageRefId,
    message,
    scheduledDate
  }, options
  /*: RequestOptions*/
  = {}) {
    const {
      businessId
    } = this.context.serialize();
    const path = `/businesses/${businessId}/social/profile/posts`;
    const body = {
      socialNetwork,
      contentType,
      imageRefId,
      message,
      scheduledDate
    };
    const req = new this.client.Request(path, body, options.fields || createFields);
    return this.client.post(req);
  }

}

class SocialPostRepo {
  constructor(client
  /*: ApiClient*/
  , id
  /*: postId*/
  , context
  /*: AccessContext*/
  ) {
    this.client = client;
    this.id = id;
    this.context = context;
  }

  details(_, options
  /*: RequestOptions*/
  = {}) {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/posts/${this.id}`, undefined, options.fields || singleFields);
    req.parse = SocialPost.parse;
    return this.client.get(req);
  }

  update(updates, options
  /*: RequestOptions*/
  = {}) {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/posts/${this.id}`, {
      message: updates.message,
      scheduledDate: updates.scheduledDate,
      state: updates.state,
      lastNotified: updates.lastNotified
    }, options.fields || singleFields);
    req.parse = SocialPost.parse;
    return this.client.patch(req);
  }

  delete({
    /*: { hard?: boolean }*/

    hard
  } = {}) {
    const {
      businessId
    } = this.context.serialize();
    const query = hard ? '?soft=false' : '';
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/posts/${this.id}${query}`);
    return this.client.delete(req);
  }

  retry({
    /*: { scheduledDate: string }*/

    scheduledDate
  }) {
    if (!scheduledDate) {
      throw new Error('Missing required parameter `scheduledDate');
    }

    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/posts/${this.id}/retry`, {
      scheduledDate
    });
    return this.client.post(req);
  }

  regenerate({
    /*: {
        shuffle: boolean,
        imageRefId?: string
      }*/

    shuffle = false,
    notify = false,
    imageRefId
  } = {}) {
    const {
      businessId
    } = this.context.serialize();
    const path = `/businesses/${businessId}/social/profile/posts/${this.id}/regenerate`;
    const payload = {
      shuffle,
      imageRefId
    };
    const req = new this.client.Request(path, payload);
    return this.client.post(req);
  }
  /**
   * Send updated generation variables like
   * [
   *   {
   *     "id": "image.heading-text",
   *     "type": "text",
   *     "value": "Woah Nelly 🐴"
   *   },
   *   ...etc
   * ]
   * The `id` and `type` values for a post come from the post details under `.variables`
   */


  modify(variables) {
    const {
      businessId
    } = this.context.serialize();
    const path = `/businesses/${businessId}/social/profile/posts/${this.id}/modify`;
    const payload = {
      variables
    };
    const req = new this.client.Request(path, payload);
    return this.client.post(req);
  }

}

module.exports = SocialPostsRepo;